import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';
import './questionPaper.css';



function QuestionPaperTbl(props) {
    const { lstSubject, lstSyllabusSelect, setLstSyllabusSelect, generateExamPatternSingle, editExamPattern, syllabusId, subjectId, setSubjectId, openPdf } = props;

    const [selSubjectId, setSelSubjectId] = useState(0);
    const [flgSelectAll, setFlgSelectAll] = useState(false);

    useEffect(() => {
        // console.log("QuestionPaperTbl called lstSubject", lstSubject);
        setSelSubjectId(subjectId);
    }, [subjectId]);

    // v1 API se aaya subject row ko purane field names mein badalo, taaki
    // ExamPatternSlider / openPdf jaise components bina change chal?? rahen
    const toLegacyShape = (sub) => ({
        syllabusId,
        subId: sub.subjectId,
        sub: sub.subject,
        pattern: sub.pattern,
        patternId: sub.patternId,
        maxMarks: sub.maxMarks,
        duration: sub.duration,
        noOfSets: sub.setCount,
        qpGeneratedDttm: sub.qpGeneratedDttm,
    });

    const selectSyllabus = (pSubjectId) => {
        // console.log("selectSyllabusCalled, pSubjectId", pSubjectId);
        const updatedLstSybId = lstSyllabusSelect.includes(pSubjectId)
            ? lstSyllabusSelect.filter((id) => id !== pSubjectId)
            : [...lstSyllabusSelect, pSubjectId];
        if (lstSubject.length === updatedLstSybId.length) {
            setFlgSelectAll(true);
        } else {
            setFlgSelectAll(false);
        }
        setLstSyllabusSelect(updatedLstSybId);
    }

    const selectAll = async (check) => {
        // console.log("selectAll called, check", check);
        let selected = [];
        if (check) {
            selected = lstSubject.map((sub) => sub.subjectId);
        }
        await setLstSyllabusSelect(selected);
        setFlgSelectAll(check);
    }

    const colgrp = <colgroup>
        <col width="50"></col>
        <col width="65"></col>
        <col width="40"></col>
        <col width="40"></col>
        <col width="40"></col>
        <col width="40"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="40"></col>
        <col width="105"></col>
    </colgroup>

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" >
                <table className='tableLayout1'>
                    {colgrp}
                    <thead>
                        <tr>
                            <th className='padding-remove'>
                                Subject
                            </th>
                            <th className='text-center'>Qus Paper Pattern</th>
                            <th className='text-center'>No. of Qus</th>
                            <th className='text-center'>Max. Marks</th>
                            <th className='text-center'>Duration</th>
                            <th className='text-center'>Pattern Saved On</th>
                            <th className='text-center'>Sets</th>
                            <th className='text-center'>
                                <div style={{ float: 'left', width: '70%', marginTop: 5 }}>Select</div>
                                <div style={{ width: '15%', float: 'left' }}>
                                    <input
                                        type="checkbox"
                                        className="form-control"
                                        checked={flgSelectAll}
                                        onChange={(e) => selectAll(e.target.checked)}
                                        onClick={(e) => { e.stopPropagation(); }}
                                        disabled={false}
                                    />
                                </div>
                            </th>
                            <th className='text-center'>Generated On</th>
                            <th className='text-center'>Action</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstSubject &&
                                lstSubject.map((sub, i) => (
                                    <tr key={sub.subjectId}
                                        onClick={() => setSubjectId(sub.subjectId)}
                                        className={sub.subjectId === selSubjectId ? "selected" : ''}>
                                        <td className="text-left">{sub.subject}</td>
                                        <td className="text-left">{sub.pattern}</td>
                                        <td className="text-center">{sub.totalQuestions}</td>
                                        <td className="text-center">{sub.maxMarks}</td>
                                        <td className="text-center">{sub.duration}</td>
                                        <td className="text-center">{sub.patternAppliedDttm}</td>
                                        <td className="text-center">{sub.setCount}</td>
                                        <td className="text-center">
                                            <input type="checkbox"
                                                className="form-check-input"
                                                checked={!!lstSyllabusSelect && lstSyllabusSelect.includes(sub.subjectId)}
                                                onChange={() => selectSyllabus(sub.subjectId)}
                                                onClick={(e) => { e.stopPropagation(); }}
                                            />
                                        </td>
                                        <td className="text-center">{sub.qpGeneratedDttm}</td>
                                        <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                            <span
                                                onClick={() => editExamPattern(toLegacyShape(sub))}
                                                title="Edit Exam Pattern"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "3px" }}
                                            >
                                                Apply Pattern
                                            </span>
                                            <span
                                                onClick={() => generateExamPatternSingle(sub.subjectId, sub.patternId, sub.setCount, sub.subject, sub.duration, sub.maxMarks)}
                                                title="Generate Exam Pattern"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "3px" }}
                                            >
                                                Generate
                                            </span>
                                            <span
                                                onClick={() => openPdf(toLegacyShape(sub))}
                                                title="View Question Paper PDF"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "3px" }}
                                            >
                                                View PDF
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default QuestionPaperTbl;